import React from 'react';
import styled from 'styled-components';
import Title from '../../components/Title';
import ImageTheme from '../../components/Images/ImageThemed';

const WrapperDiv = styled.div`
    height: 100%;
    width: 100%;
    padding: 2rem;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    background-color: var(--color-background);
    text-align: center;
`;

const ImgDiv = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

function ErrorOrientation() {
    const errorMessage = 'Por favor, coloque el celular de forma vertical';

    return (
        <WrapperDiv class id='turn' style={{ }}>
            <Title >{errorMessage}</Title>
            <ImgDiv>
                <ImageTheme src="/logo.png" width="250" />
            </ImgDiv>
        </WrapperDiv>
    );
}

export default ErrorOrientation;
